import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'no-content',
    template: `
    <div>
      <h1>404: page missing</h1>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoContentPageComponent {}
